import { defineComponent as _defineComponent } from 'vue'
import { ref, toRefs, watch, computed, useContext } from "@nuxtjs/composition-api";
import { MetaUser } from "~/core/models/MetaUser";
import { ACTIONS as ACTIONS_USER_FEEDBACK, GETTERS as GETTERS_USER_FEEDBACK } from "~/store/affility/user/feedback/names";
import { useMobile } from "~/core/composables/useMobile";
import useHiddenWalletAddress from "~/core/composables/useHiddenWalletAddress";

interface Props {
    visible?: boolean,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'WrongWallet',
  props: {
    visible: { type: Boolean }
  },
  emits: ['input', 'onPopupClose'],
  setup(__props: any, { emit: $emit }) {

const props = __props as { visible?: boolean };





const {
    visible,
} = toRefs(props);

const { store } = useContext();
const isMobile = useMobile();
const internalVisible = ref(visible.value);

const user = computed<MetaUser>(() => store.getters['application/driver/authUser']);
const currentWallet = computed<string>(() => store.getters[
    `affility/user/feedback/${GETTERS_USER_FEEDBACK.WRONG_WALLET_MODAL_ADDRESS}`]);

const getHiddenAddress = (address: string) => useHiddenWalletAddress(address).value;

const handleClose = () => {
    store.dispatch(
        `affility/user/feedback/${ACTIONS_USER_FEEDBACK.SHOW_WRONG_WALLET_MODAL}`,
        { show: false }
    );
}

watch(visible, (value) => {
    internalVisible.value = value;
});

watch(internalVisible, (value) => {
    if (value === visible.value) {
        return;
    }
    $emit('input', value);
});

return { __sfc: true,props, $emit, visible, store, isMobile, internalVisible, user, currentWallet, getHiddenAddress, handleClose }
}

})